import {fabric} from 'fabric';
import _ from 'lodash';
import DefaultSquare from '../nuclide/levelhelpers/DefaultSquare';
import RowColSquare from '../nuclide/levelhelpers/RowColSquare';
import SquareGrid from '../nuclide/levelhelpers/SquareGrid';

export default function createFive(nuclide, nuclideData) {
    let items = [];

    if(nuclide.isRow || nuclide.isColumn) {
        new RowColSquare(nuclide, items, 32, false);
    } else {
        let square = new DefaultSquare(nuclide, items, 32);

        if (nuclide.location !== 'empty') {
            square.addBlackBand(9);
            square.addName(6);
        }

        let grid = new SquareGrid(items, nuclide, 32, nuclideData);
        grid.createGrid(5);
    }

    let group = new fabric.Group(items, {
        objectCaching: false,
        opacity: nuclide.opacity
    });

    return group;
};

